<template>
  <div>
    <div>
      If
      <el-select
        v-if="fromFilters"
        v-model="currentFilter.c_query_type"
        placeholder="Query Type"
        size="mini"
      >
        <el-option value="AND" label="All">All</el-option>
        <el-option value="OR" label="Any One">Any One</el-option>
      </el-select>
      <el-select v-else v-model="currentFilter.query_type" placeholder="Query Type" size="mini">
        <el-option value="AND" label="All">All</el-option>
        <el-option value="OR" label="Any One">Any One</el-option>
      </el-select>
      of the following are
      <b>true</b>
    </div>
    <div class="mt-1" v-if="showName">
      <label for="text">Filter Name :</label>
      <el-input
        v-model="currentFilter.name"
        placeholder="Enter Name"
        size="mini"
        :width="192"
      ></el-input>
    </div>
    <el-scrollbar wrap-style="max-height: 150px;" ref="configureScroll">
      <div
        class="rule-row mt-1"
        v-for="(rule, index) in currentFilter.conditions"
        :key="index + '_conditions'"
      >
        <div class="rule-inner-row">
          <div class="select-container">
            <el-select
              v-model="rule.selectField"
              size="mini"
              placeholder="Select Field"
              @change="(changedValue) => checkCurrentFieldData(changedValue, rule)"
              filterable
            >
              <el-option
                v-for="(op, i) in [...includeDataTableFields]
                  .filter((e) => e.inputType !== 'DATA_TABLE' && e.inputType !== 'ENTITY_TABLE')
                  .sort((a, b) => a.label.localeCompare(b.label))"
                :key="i + op.key"
                :value="op.key"
                :label="op.label"
              >
                {{ op.label }}
              </el-option>
              <template v-if="!fromEntityViews && !formQuickActions && !fromScheduling">
                <el-option value="userType" label="User Type"></el-option>
                <el-option value="IsUserType" label="Is User Type"></el-option>
                <el-option value="apply_rules" label="Apply Rules At"></el-option>
                <el-option value="created_by" label="Created By"></el-option>
                <el-option value="updated_by" label="Updated By"></el-option>
                <el-option value="created_at" label="Created Date"></el-option>
                <el-option value="updated_at" label="Updated Date"></el-option>
              </template>
              <template v-else-if="fromEntityViews && dividerIncluded">
                <el-option value="compare_slots" label="Frequency slots">
                  <span style="color: #13ce66">Frequency Slot</span>
                </el-option>
              </template>
            </el-select>
            <span
              class="error_msg"
              v-if="currentFilter.conditions[index].error_msg && !rule.selectedField"
            >
              {{ currentFilter.conditions[index].error_msg }}
            </span>
          </div>
          <el-select
            v-model="rule.operator"
            v-if="rule.data_type !== 'BOOLEAN' && rule.selectField != 'apply_rules'"
            size="mini"
            :disabled="!rule.selectField"
            placeholder="Operator"
            class="ml-1"
            filterable
          >
            <el-option
              v-for="(operator, index) of getCurrentFieldOperators(rule)"
              :key="index + '_operator'"
              :label="operator.title"
              :value="operator.value"
            ></el-option>
            <template v-if="(fromEntityViews || formQuickActions) && rule.linked_to_slots">
              <el-option value="APPROVED" label="Approved"></el-option>
              <el-option value="PENDING" label="Need to be approved"></el-option>
            </template>
            <!-- <template
              v-if="rule.selectField && isHierarchyObject[rule.selectField]"
            >
              <el-option
                value="HIGHEST_LEVEL"
                label="Is Highest level in the Hierarchy"
              >
              </el-option>
              <el-option
                value="LOWEST_LEVEL"
                label="Is Lowest level in the Hierarchy"
              >
              </el-option>
            </template> -->
          </el-select>
          <el-select
            v-if="rule.selectField == 'compare_slots' && rule.operator"
            v-model="rule.start_date"
            size="mini"
            placeholder="Start Date"
            filterable
          >
            <el-option
              v-for="(op, i) in [...includeDataTableFields]
                .filter((e) => e.inputType == 'DATE')
                .sort((a, b) => a.label.localeCompare(b.label))"
              :key="i + op.key"
              :value="op.key"
              :label="op.label"
            >
              {{ op.label }}
            </el-option>
          </el-select>
          <el-select
            v-if="rule.selectField == 'compare_slots' && rule.operator && rule.start_date"
            v-model="rule.frequency"
            size="mini"
            placeholder="Frequency"
            filterable
          >
            <el-option
              v-for="(op, i) in [...includeDataTableFields]
                .filter(
                  (e) => ['NUMBER', 'LIST'].includes(e.inputType) && e.key !== rule.start_date
                )
                .sort((a, b) => a.label.localeCompare(b.label))"
              :key="i + op.key"
              :value="op.key"
              :label="op.label"
            >
              {{ op.label }}
            </el-option>
          </el-select>
          <div
            v-if="
              ['exists', 'notexists', 'click', 'APPROVED', 'PENDING', 'value_changes'].indexOf(
                rule.operator
              ) == -1
            "
            class="d-flex"
          >
            <el-select
              v-model="rule.data_source"
              size="mini"
              placeholder="Value Type"
              :disabled="!rule.operator"
              class="ml-1 mr-1"
              filterable
              v-if="
                rule.data_type != 'BOOLEAN' &&
                rule.data_type != 'userType' &&
                rule.data_type != 'IsUserType' &&
                rule.selectField != 'apply_rules' &&
                rule.input_type != 'QUESTION' &&
                rule.selectField != 'compare_slots'
              "
            >
              <template v-if="checkIsSelect(rule)">
                <el-option value="field_option" label="From Field"></el-option>
              </template>
              <template v-else>
                <el-option
                  v-for="(source, index) of allowedDataSources(rule)"
                  :key="index + '_data_source'"
                  :label="source"
                  :value="source"
                ></el-option>
                <el-option
                  value="TEMPLATE"
                  label="TEMPLATE"
                  v-if="
                    rule.operator != 'between' &&
                    rule.data_type != 'created_by' &&
                    rule.data_type != 'updated_by' &&
                    rule.data_type != 'created_at' &&
                    rule.data_type != 'updated_at' &&
                    !rule.show_count &&
                    rule.data_type != 'INTEGRATIONS'
                  "
                >
                  TEMPLATE
                </el-option>
                <el-option
                  value="event_data"
                  label="EVENT_DATA_LIST"
                  v-if="
                    rule.operator != 'between' &&
                    rule.input_type == 'INTEGRATION' &&
                    (rule.operator == 'in' || rule.operator == 'nin') &&
                    rule.data_type != 'created_by' &&
                    rule.data_type != 'updated_by' &&
                    rule.data_type != 'created_at' &&
                    rule.data_type != 'updated_at' &&
                    !rule.show_count
                  "
                >
                  EVENT_DATA_LIST
                </el-option>
                <el-option
                  value="login"
                  label="Login User"
                  v-if="rule.data_type == 'created_by' || rule.data_type == 'updated_by'"
                ></el-option>
                <el-option
                  value="value"
                  label="VALUE"
                  v-if="
                    rule.data_type == 'created_by' ||
                    rule.data_type == 'updated_by' ||
                    rule.data_type == 'VARIABLE' ||
                    rule.show_count
                  "
                ></el-option>
                <el-option
                  v-if="rule.input_type == 'DATE' || rule.result_type == 'DATE'"
                  value="TODAY"
                  label="today"
                >
                  Today
                </el-option>
                <el-option
                  value="GLOBAL_VARIABLE"
                  label="GLOBAL_VARIABLE"
                  v-if="
                    rule.input_type == 'SINGLE_LINE_TEXT' ||
                    (rule.input_type == 'NUMBER' && rule.operator != 'between')
                  "
                >
                  GLOBAL_VARIABLE
                </el-option>
                <el-option
                  v-if="
                    rule.data_type == 'STRING' && allowedLoginRuleOp.indexOf(rule.operator) != -1
                  "
                  value="login_user"
                  label="FROM LOGIN USER"
                ></el-option>
              </template>
            </el-select>

            <el-select
              v-if="rule.input_type === 'YES_OR_NO'"
              v-model="rule.value"
              size="mini"
              style="margin-left: 10px"
            >
              <el-option value="YES" label="YES">Yes</el-option>
              <el-option value="NO" label="NO">No</el-option>
            </el-select>
            <el-select
              v-if="rule.data_source == 'GLOBAL_VARIABLE'"
              v-model="rule.value"
              size="mini"
              no-data-text="No Global Variables with Field"
              @change="(value) => addGlobalVaraibleData(value, rule)"
            >
              <el-option
                v-for="(gbVab, index) of selectedGlobalVariablesList(rule)"
                :key="index"
                :label="`${gbVab.label} -> ${gbVab.value ? gbVab.value : ''}`"
                :value="gbVab._id"
              ></el-option>
            </el-select>
            <el-select
              v-model="rule.value"
              size="mini"
              v-if="rule.data_source == 'login_user'"
              @change="(changedValue) => checkCurrentFieldValue(changedValue, rule)"
            >
              <el-option
                v-for="(op, index) in loginUserFields"
                :key="index + op.value"
                :label="op.label"
                :value="op.value"
              >
                {{ op.label }}
              </el-option>
            </el-select>
            <el-select
              v-if="rule.data_type === 'userType'"
              v-model="rule.value"
              size="mini"
              multiple
              collapse-tags
              style="margin-left: 10px"
            >
              <el-option
                v-for="(user, index) in getUserTypeList"
                :key="index"
                :label="user.role.title + '->' + user.name"
                :value="user._id"
              ></el-option>
            </el-select>
            <el-input-number
              v-if="
                rule.show_count &&
                rule.input_type == 'ENTITY' &&
                rule.data_source == 'value' &&
                rule.data_source !== 'TEMPLATE'
              "
              v-model="rule.value"
              :controls="false"
              size="mini"
              placeholder="Enter Number"
              style="margin-right: 15px"
            ></el-input-number>
            <div
              style="display: flex"
              v-if="
                (rule.input_type == 'NUMBER' ||
                  rule.input_type == 'CURRENCY' ||
                  rule.input_type == 'FORMULA' ||
                  rule.input_type == 'AGGREGATE_FUNCTION' ||
                  rule.input_type == 'STAR_RATING') &&
                rule.operator == 'between' &&
                rule.data_source != 'TEMPLATE' &&
                rule.data_source == 'VALUE'
              "
            >
              <el-input-number
                v-model="rule.startValue"
                :controls="false"
                size="mini"
                placeholder="Starting Value"
                style="width: 70px"
              ></el-input-number>
              <span>To&nbsp;</span>
              <el-input-number
                v-model="rule.endValue"
                :controls="false"
                size="mini"
                placeholder="Ending Value"
                style="width: 70px"
              ></el-input-number>
            </div>
            <div
              style="display: flex"
              v-if="
                rule.input_type === 'DATE' &&
                rule.operator == 'ranges' &&
                rule.data_source === 'VALUE'
              "
            >
              <el-date-picker
                v-model="rule.startValue"
                type="date"
                size="mini"
                placeholder="Starting Date"
                style="margin-right: 15px"
              ></el-date-picker>
              <span>To&nbsp;</span>
              <el-date-picker
                v-model="rule.endValue"
                type="date"
                placeholder="Ending Date"
                size="mini"
                style="margin-left: 15px"
              ></el-date-picker>
            </div>
            <el-select
              v-if="rule.data_type === 'IsUserType'"
              v-model="rule.value"
              size="mini"
              style="margin-left: 10px"
            >
              <el-option value="ApplicationUser-Entities" label="ApplicationUser-Entities">
                ApplicationUser-Entities
              </el-option>
              <el-option value="ApplicationUser" label="ApplicationUser">ApplicationUser</el-option>
              <el-option value="CompanyUser" label="CompanyUser">CompanyUser</el-option>
            </el-select>
            <el-select
              v-if="rule.input_type === 'IsUserType' && rule.value === 'ApplicationUser-Entities'"
              v-model="rule.application_user_types"
              size="mini"
              multiple
              collapse-tags
              style="margin-left: 10px"
            >
              <el-option
                v-for="(user, index) in filteredEntities"
                :key="index"
                :label="user.name"
                :value="user._id"
              ></el-option>
            </el-select>
            <el-select
              v-if="
                (rule.input_type === 'created_by' || rule.input_type === 'updated_by') &&
                rule.data_source == 'value' &&
                rule.data_source != 'login'
              "
              v-model="rule.value"
              size="mini"
              multiple
              collapse-tags
              style="margin-left: 10px"
            >
              <el-option
                v-for="(user, index) in users.data"
                :key="index"
                :label="user.email"
                :value="user._id"
              ></el-option>
            </el-select>
            <el-select
              v-if="rule.selectField === 'apply_rules'"
              v-model="rule.value"
              size="mini"
              style="margin-left: 10px"
            >
              <el-option value="FormBuilders" label="FormBuilders">FormBuilders</el-option>
              <el-option value="Entities" label="Entities">Entities</el-option>
              <el-option value="Both" label="Both">Both</el-option>
            </el-select>
            <el-select
              v-if="rule.selectField === 'apply_rules' && rule.value == 'FormBuilders'"
              v-model="rule.formbuilderId"
              size="mini"
              style="margin-left: 10px"
            >
              <el-option
                v-for="form in formbuildersList"
                :key="form._id"
                :value="form._id"
                :label="form.name"
              ></el-option>
            </el-select>
            <el-select
              v-if="rule.input_type === 'WEEKDAYS'"
              v-model="rule.value"
              size="mini"
              multiple
              collapse-tags
            >
              <el-option
                v-for="(dt, index) of weekdayOptions"
                :key="index + '_field_option'"
                :label="dt.name"
                :value="dt.value"
              >
                {{ dt.name }}
              </el-option>
            </el-select>

            <!-- <el-select
                  v-model="rule.value"
                  size="mini"
                  v-if="
                    rule.data_source == 'TODAY' && rule.input_type == 'DATE'
                  "
                >
                  <el-option :label="todayDate" :value="todayDate"></el-option>
                </el-select> -->
            <el-select
              v-if="
                rule.input_type === 'STAR_RATING' &&
                rule.data_source == 'VALUE' &&
                rule.operator != 'between'
              "
              v-model="rule.value"
              size="mini"
            >
              <el-option
                v-for="(dt, index) of starRating_options"
                :key="index + '_field_option'"
                :label="dt.name"
                :value="dt.value"
              >
                {{ dt.name }}
              </el-option>
            </el-select>
            <el-select
              v-else-if="rule.input_type === 'CHECKBOX'"
              v-model="rule.value"
              size="mini"
              style="margin-left: 10px"
            >
              <el-option :value="true" label="checked">Checked</el-option>
              <el-option :value="false" label="unchecked">Unchecked</el-option>
            </el-select>
            <el-select v-else-if="rule.input_type === 'RADIO'" v-model="rule.value" size="mini">
              <el-option :value="true" label="checked">Checked</el-option>
              <el-option :value="false" label="unchecked">Unchecked</el-option>
            </el-select>
            <el-select
              v-model="rule.value"
              v-else-if="rule.data_type == 'INTEGRATION' && rule.data_source == 'event_data'"
              multiple
              collapse-tags
              size="mini"
            >
              <el-option
                v-for="(temp, i) in ruleIntegrationOptions[rule.selectField] || []"
                :key="temp.id + '_' + i"
                :value="temp.id"
                :label="temp.name"
              >
                {{ temp.name }}
              </el-option>
            </el-select>
            <el-select
              v-model="rule.value"
              v-else-if="rule.data_source == 'ENTITY_DATA_LIST' && rule.input_type != 'YES_OR_NO'"
              multiple
              collapse-tags
              size="mini"
            >
              <el-option
                v-for="(temp, i) in entilistAsOptions(rule)"
                :key="temp._id + '_' + index + '_' + i"
                :value="temp._id"
                :label="getLabel(temp, i)"
              >
                {{ getLabel(temp, i) }}
              </el-option>
            </el-select>
            <el-select
              v-model="rule.value"
              v-else-if="rule.input_type == 'LIST'"
              size="mini"
              :multiple="checkIsMultiple(rule)"
            >
              <el-option
                v-for="gr in filteredFields(rule.selectField)"
                :key="gr.key + '_gr'"
                :value="gr.key"
                :label="gr.label"
              ></el-option>
              <el-option
                v-for="(dt, index) of getCurrentFieldOptions(rule)"
                :key="index + '_field_option'"
                :label="dt.name"
                :value="`${dt.value}_${dt.name}`"
              >
                {{ dt.name }}
              </el-option>
            </el-select>
            <el-select
              v-model="rule.value"
              v-else-if="
                rule.data_source == 'field_option' &&
                rule.input_type != 'WEEKDAYS' &&
                rule.data_type != 'userType' &&
                rule.data_type != 'IsUserType' &&
                rule.integrationType != 'select'
              "
              collapse-tags
              size="mini"
              :multiple="checkIsMultiple(rule)"
              style="width: 180px"
            >
              <!-- <el-option v-for="gr in filteredFields(rule.selectField)" :key="gr.key + '_gr'" :value="gr.key"
                    :label="gr.label"></el-option> -->
              <el-option
                v-for="(dt, index) in getCurrentFieldOptions(rule)"
                :key="index + '_field_option'"
                :label="dt"
                :value="dt"
              >
                {{ dt }}
              </el-option>
            </el-select>
            <el-select
              v-model="rule.value"
              v-else-if="
                rule.integrationType == 'select' &&
                rule.input_type == 'INTEGRATION_VARIABLE' &&
                rule.data_source == 'field_option'
              "
              collapse-tags
              size="mini"
              :multiple="checkIsMultiple(rule)"
              style="width: 180px"
            >
              <el-option
                v-for="(dt, index) in getCurrentFieldOptions(rule)"
                :key="index + '_field_option'"
                :label="dt.label"
                :value="`${dt.value}`"
              >
                {{ dt.label }}
              </el-option>
            </el-select>
            <el-select
              v-model="rule.value"
              v-else-if="
                rule.data_source == 'TEMPLATE' &&
                rule.input_type !== 'CHECKBOX_GROUP' &&
                rule.operator != 'between'
              "
              size="mini"
              placeholder="Select template field"
              multiple
              collapse-tags
            >
              <el-option
                v-for="(temp, i) in geTemplateFieldsByType(rule)"
                :key="temp.key + '_' + index + '_' + i"
                :value="temp.key"
                :label="temp.label"
              >
                {{ temp.label }}
              </el-option>
            </el-select>
            <el-input-number
              v-model="rule.value"
              v-else-if="
                rule.data_source == 'VALUE' &&
                rule.data_type == 'NUMBER' &&
                rule.operator != 'between'
              "
              :controls="false"
              size="mini"
            ></el-input-number>
            <el-input
              v-model="rule.value"
              v-if="
                (rule.input_type === 'SINGLE_LINE_TEXT' ||
                  rule.integrationType == 'text' ||
                  rule.input_type == 'CONCATENATE' ||
                  rule.input_type == 'ACTION_BUTTON') &&
                rule.data_source != 'TEMPLATE' &&
                rule.data_source != 'GLOBAL_VARIABLE' &&
                rule.data_source != 'login_user'
              "
              :controls="false"
              placeholder="Enter text"
              :disabled="!rule.operator"
              size="mini"
            ></el-input>
            <el-input
              v-model="rule.value"
              v-if="
                rule.input_type === 'MULTI_LINE_TEXT' &&
                rule.data_source != 'TEMPLATE' &&
                rule.data_source != 'GLOBAL_VARIABLE' &&
                rule.data_source != 'login_user'
              "
              :controls="false"
              placeholder="Enter text"
              :disabled="!rule.operator"
              size="mini"
            ></el-input>
            <el-date-picker
              v-model="rule.value"
              size="mini"
              v-else-if="
                rule.data_source == 'VALUE' && rule.data_type == 'DATE' && rule.operator != 'ranges'
              "
              :format="
                getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
                  ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
                  : 'MM-dd-yyyy'
              "
            ></el-date-picker>
            <el-date-picker
              v-model="rule.value"
              size="mini"
              v-else-if="
                (rule.data_source === 'VALUE' && rule.data_type === 'created_at') ||
                (rule.integrationType === 'date' && rule.data_source !== 'TEMPLATE') ||
                (rule.data_source !== 'TEMPLATE' && rule.data_type === 'updated_at')
              "
              :format="
                getDefaultDateFormat && getDefaultDateFormat.includes('Do') == false
                  ? getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
                  : 'MM-dd-yyyy'
              "
            ></el-date-picker>

            <!-- <el-date-picker
                v-else-if="
                  rule.data_source === 'VALUE' &&
                  rule.data_type === 'DATE_RANGE' 
                  
                "
                v-model="rule.value"
                type="daterange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                size="mini"
              ></el-date-picker> -->
            <el-time-picker
              v-model="rule.value"
              size="mini"
              v-else-if="
                rule.data_source === 'VALUE' &&
                rule.data_type === 'TIME' &&
                rule.operator != 'ranges'
              "
              :picker-options="{ format: 'HH:mm:ss' }"
            ></el-time-picker>

            <el-date-picker
              v-else-if="rule.data_source === 'VALUE' && rule.data_type === 'DATE_TIME'"
              v-model="rule.value"
              type="datetime"
              size="mini"
              placeholder="Select date and time"
            ></el-date-picker>
            <el-date-picker
              v-else-if="rule.data_source === 'VALUE' && rule.data_type === 'DATE_TIME_RANGE'"
              v-model="rule.value"
              type="datetimerange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              size="mini"
            ></el-date-picker>
            <P v-else-if="rule.data_type == 'userType'"></P>
            <P v-else-if="rule.input_type == 'IsUserType'"></P>
            <!-- <el-input
                  v-else
                  :disabled="!rule.data_source"
                  v-model="rule.value"
                  placeholder="Value"
                  size="mini"
                  class="ml-1"
                >
                </el-input> -->
          </div>
          <div class="d-flex">
            <el-checkbox
              v-if="
                currentFilter.conditions.find(
                  (e, i) => e.selectField == 'compare_slots' && index !== i
                )
              "
              v-model="rule.linked_to_slots"
            ></el-checkbox>
            <el-select
              v-model="rule.column"
              size="mini"
              placeholder="Select column"
              filterable
              v-if="rule.linked_to_slots"
            >
              <el-option
                v-for="(op, i) in dividerColumnEntityFields.filter(
                  (e) => e.entity_id == rule.linked_entity_id
                )"
                :key="i + '_field_' + op.key"
                :value="op.key"
                :label="op.label"
              >
                {{ op.label }}
              </el-option>
            </el-select>
          </div>
        </div>
        <el-link class="mr-1" type="primary" :underline="false" @click="addNewCondition(false)">
          <i class="el-icon-circle-plus"></i>
        </el-link>
        <el-link
          class="mr-1"
          type="danger"
          :underline="false"
          @click="deleteCondition(index)"
          :disabled="currentFilter.conditions.length == 1"
        >
          <i class="el-icon-remove"></i>
        </el-link>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
  import AutomationHelper from '../../mixins/AutomationHelper';
  import TemplateFormRules from '../../mixins/TemplateFormRules';
  export default {
    props: [
      'currentFilter',
      'allFields',
      'formQuickActions',
      'fromEntityViews',
      'dividerIncluded',
      'fromScheduling',
      'isHierarchyObject',
      'fromFilters',
      'showName',
    ],
    mixins: [AutomationHelper, TemplateFormRules],
    data() {
      return {
        entityDataInfo: [],
      };
    },
    methods: {
      addNewCondition() {
        this.$emit('addNewCondition');
      },
      deleteCondition(index) {
        this.$emit('deleteCondition', index);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .rule-row {
    display: flex !important;
    background: #f2f6fc;
    height: 65px;

    .rule-inner-row {
      display: grid;
      margin: auto;
      margin-right: 25px;
      margin-left: 25px;
      grid-template-columns: auto auto auto auto;
    }

    .select-container {
      display: flex;
      flex-direction: column;
      margin-right: 25px;
    }
  }
</style>
